import React from 'react';

function Burundi(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124186)">
        <mask
          id="mask0_800_124186"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124186)">
          <rect width="36" height="24" rx="2" fill="#5EAA22" />
          <mask
            id="path-4-outside-1_800_124186"
            maskUnits="userSpaceOnUse"
            x="-9"
            y="-3"
            width="54"
            height="30"
            fill="black"
          >
            <rect fill="white" x="-9" y="-3" width="54" height="30" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 12L36 0H0L18 12ZM18 12L0 24H36L18 12Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 12L36 0H0L18 12ZM18 12L0 24H36L18 12Z"
            fill="#DD2C2B"
          />
          <path
            d="M36 0L37.3867 2.08013L44.2569 -2.5H36V0ZM0 0V-2.5H-8.25694L-1.38675 2.08013L0 0ZM0 24L-1.38675 21.9199L-8.25694 26.5H0V24ZM36 24V26.5H44.2569L37.3867 21.9199L36 24ZM34.6132 -2.08013L16.6133 9.91987L19.3868 14.0801L37.3867 2.08013L34.6132 -2.08013ZM0 2.5H36V-2.5H0V2.5ZM19.3868 9.91987L1.38675 -2.08013L-1.38675 2.08013L16.6133 14.0801L19.3868 9.91987ZM16.6133 9.91987L-1.38675 21.9199L1.38675 26.0801L19.3868 14.0801L16.6133 9.91987ZM0 26.5H36V21.5H0V26.5ZM37.3867 21.9199L19.3868 9.91987L16.6133 14.0801L34.6132 26.0801L37.3867 21.9199Z"
            fill="white"
            mask="url(#path-4-outside-1_800_124186)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 18C21.7279 18 24.75 15.3137 24.75 12C24.75 8.68629 21.7279 6 18 6C14.2721 6 11.25 8.68629 11.25 12C11.25 15.3137 14.2721 18 18 18Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3588 10.3873L16.0515 10.4L16.7176 9.40002L16.0515 8.40002L17.3588 8.41275L18.0001 7.40002L18.6413 8.41275L19.9486 8.40002L19.2826 9.40002L19.9486 10.4L18.6413 10.3873L18.0001 11.4L17.3588 10.3873Z"
            fill="#DD2C2B"
            stroke="#5EAA22"
            strokeWidth="0.25"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5463 14.4873L13.239 14.5L13.9051 13.5L13.239 12.5L14.5463 12.5127L15.1876 11.5L15.8288 12.5127L17.1361 12.5L16.4701 13.5L17.1361 14.5L15.8288 14.4873L15.1876 15.5L14.5463 14.4873Z"
            fill="#DD2C2B"
            stroke="#5EAA22"
            strokeWidth="0.25"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.1713 14.4873L18.864 14.5L19.5301 13.5L18.864 12.5L20.1713 12.5127L20.8126 11.5L21.4538 12.5127L22.7611 12.5L22.0951 13.5L22.7611 14.5L21.4538 14.4873L20.8126 15.5L20.1713 14.4873Z"
            fill="#DD2C2B"
            stroke="#5EAA22"
            strokeWidth="0.25"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124186">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Burundi;
